// constants
import { NEWRELIC_TABLES } from "@checkout-core/constants/NewRelicTables";

// NR
import { recordNREvent } from "@checkout-core/newrelic";

// utils
import { isEmpty } from "@swiggy-private/js-utils";

export const isValidUtf8 = (value: string): boolean => {
    // eslint-disable-next-line no-control-regex
    const utf8Regex = /^(?:(?:(?:[\x00-\x7F]|[\xC2-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF4][\x80-\xBF]{3})*)*)$/;

    return utf8Regex.test(value);
};

export const convertToUtf8 = (value: string): string => {
    const textEncoder = new TextEncoder();

    // Encode the string to UTF-8
    const utf8Array = textEncoder.encode(value);

    // Convert the UTF-8 byte array to a string for display or further processing
    const utf8String = String.fromCharCode(...Array.from(utf8Array));

    return utf8String;
};

export const filterValidHeaders = (headers: HeadersInit): HeadersInit => {
    const invalidHeaders: HeadersInit = {};

    const validHeaders = Object.keys(headers).reduce<HeadersInit>((acc, cur) => {
        const headerValue = headers[cur as keyof typeof headers];

        if (headerValue != null && !Number.isNaN(headerValue) && headerValue !== "") {
            const stringifiedHeaderValue = String(headerValue);
            const isValidHeader = isValidUtf8(stringifiedHeaderValue);

            if (isValidHeader) {
                // if valid value, use it directly
                acc[cur as keyof typeof headers] = stringifiedHeaderValue;
            } else {
                invalidHeaders[cur] = stringifiedHeaderValue;
                // if invalid value, convert to utf 8 before using it
                acc[cur as keyof typeof headers] = convertToUtf8(stringifiedHeaderValue);
            }
        }
        return acc;
    }, {});

    if (!isEmpty(invalidHeaders)) {
        recordNREvent({ eventType: NEWRELIC_TABLES.CW_INVALID_HEADERS, ...invalidHeaders });
    }

    return validHeaders;
};
